export enum ExportType {
  META = 1,
  Documents = 2,
  Security = 3,
  SiteArchiveWindowsExplorer = 4,
  SiteArchiveStandard = 5,
  EssentialDocuments = 6,
  FolderArchive = 7,
  Audit = 8,
  AlfrescoMetadata = 9,
  DocumentTypes = 10,
  Datarooms = 11,
  CalendarTasks = 12,
  DocumentsAuditTrail = 13,
  Queries = 14,
  Search = 15,
  Contacts = 16,
  Records = 17,
  Organizations = 18,
}

export const SearchResultsExportLimit = 10000;
